<template>
  <div class="subheader">
    {{ text }}
    <Icon v-if="tooltip" :tooltip="tooltip" name="info" />
  </div>
</template>

<script>
import { Icon } from '@alpha/ink'

export default {
  components: {
    Icon
  },
  props: {
    text: {
      type: String,
      required: true
    },
    tooltip: {
      type: [String, Boolean, Object],
      default: false
    }
  }
}
</script>

<style scoped>
.subheader {
  background-color: #f1f1f1;
  text-transform: uppercase;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.3;
  color: #888;
  padding: 6px 26px;
}
</style>
